import axiosInstance from "../axiosConfig";
import {
    ENDPOINT_NOTIFICATIONS,
    ENDPOINT_NOTIFICATION_READ,
    ENDPOINT_NOTIFICATIONS_READ_ALL,
    ENDPOINT_NOTIFICATIONS_UNREAD_COUNT
} from "../../constants";

export type Notification = {
    id: string;
    user_id?: string;
    target_roles?: string[];
    ref_id?: string;
    type: string;
    title: string;
    content: string;
    link: string;
    read: boolean;
    created_at: number;
    expires_at: number;
    company_id?: string;
    meta?: Record<string, any>;
};

export type NotificationsResponse = {
    notifications: Notification[];
};

export type UnreadCountResponse = {
    count: number;
};

export interface ApiSuccessResponse<T> {
    Code: string;
    Msg: T;
}

export async function fetchNotifications(): Promise<ApiSuccessResponse<NotificationsResponse>> {
    try {
        const url = ENDPOINT_NOTIFICATIONS;
        const response = await axiosInstance.get(url, { withCredentials: true });
        return response.data;
    } catch (err) {
        console.error("fetchNotifications error:", err);
        throw err;
    }
}

export async function markAsRead(id: string): Promise<ApiSuccessResponse<string>> {
    try {
        const response = await axiosInstance.post(ENDPOINT_NOTIFICATION_READ, { id }, { withCredentials: true });
        return response.data;
    } catch (err) {
        console.error("markAsRead error:", err);
        throw err;
    }
}

export async function markAllAsRead(): Promise<ApiSuccessResponse<string>> {
    try {
        const response = await axiosInstance.post(ENDPOINT_NOTIFICATIONS_READ_ALL, {}, { withCredentials: true });
        return response.data;
    } catch (err) {
        console.error("markAllAsRead error:", err);
        throw err;
    }
}

export async function fetchUnreadCount(): Promise<ApiSuccessResponse<UnreadCountResponse>> {
    try {
        const response = await axiosInstance.get(ENDPOINT_NOTIFICATIONS_UNREAD_COUNT, { withCredentials: true });
        return response.data;
    } catch (err) {
        console.error("fetchUnreadCount error:", err);
        throw err;
    }
}
